import m from "../../geodata/es2015/georgiaSouthOssetiaLow";
window.am4geodata_georgiaSouthOssetiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/georgiaSouthOssetiaLow.js
// module id = null
// module chunks = 